import { api } from "./api.js";

export async function downloadReportCsv(
  name: string,
  from: string,
  to: string
): Promise<void> {
  const text = await api.reportCsv(name, {
    from: from || undefined,
    to: to || undefined,
  });
  const blob = new Blob([text], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = `${name}.csv`;
  anchor.click();
  URL.revokeObjectURL(url);
}
